import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MDTask } from '@helpers/types/models';
import { Router } from '@angular/router';
import { ManualDippingResultsTableService } from '../manual-dipping-view-results/manual-dipping-results-table/manual-dipping-results-table.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, finalize } from 'rxjs';
import { ManualDippingService } from '../manual-dipping.service';
import { UserService } from '../../../auth/user.service';

@Component({
	selector: 'app-manual-dipping-results',
	standalone: false,
	templateUrl: './manual-dipping-results.component.html',
	styleUrl: './manual-dipping-results.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualDippingResultsComponent {
	mdTask!: MDTask;

	readonly exporting$ = new BehaviorSubject<boolean>(false);
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		private readonly dialogRef: DialogRef<boolean>,
		@Inject(DIALOG_DATA) readonly data: { mdTask: MDTask, paging: Partial<any> },
		private readonly router: Router,
		private readonly service: ManualDippingResultsTableService,
		protected readonly user: UserService,
		private readonly manualDippingService: ManualDippingService
	) {
		this.mdTask = this.data.mdTask;
	}

	confirm(): void {
		if (this.mdTask && this.mdTask.mdTaskID !== null) {
			this.exporting$.next(true);
			this.service
				.export(this.mdTask.mdTaskID)
				.pipe(
					takeUntilDestroyed(this.destroyRef),
					finalize(() => this.exporting$.next(false))
				)
				.subscribe();
		}
	}

	close(): void {
		this.dialogRef.close(false);
	}

	goToResults(): void {
		this.router.navigate(['manual_dipping_results/', this.mdTask.mdTaskID]).then(() => this.close());
	}

	exportNumbers(): void {
		if (this.mdTask && this.mdTask.mdTaskID !== null) {
			this.exporting$.next(true);
			this.service
				.exportNumbers(this.mdTask.mdTaskID)
				.pipe(
					takeUntilDestroyed(this.destroyRef),
					finalize(() => this.exporting$.next(false))
				)
				.subscribe();
		}
	}

	restart(): void {
		const param = {
			Sources: this.mdTask.sources,
			NoCache: this.mdTask.noCache,
			Numbers: this.mdTask.numbers
		};
		this.manualDippingService
			.create(param)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (resp.data.mdTaskID) {
					this.manualDippingService.refresh$.next(true);
					this.dialogRef.close(true);
				}
			});
	}
}
